import { Component, ViewChild } from '@angular/core'
import { ResourceGroupsComponent } from 'app/shared/components/resource-groups'
import { ResourceType } from '@mprep/shared/data/models'
import { AppStateService } from '../shared/'


@Component({
  selector: 'mp-ebook-resources',
  templateUrl: './ebook-resources.html',
  styleUrls: ['./ebook-resources.scss']
})
export class EbookResourcesComponent {
  @ViewChild(ResourceGroupsComponent)
  resourceGroupsComponent: ResourceGroupsComponent

  constructor(
    private _appStateService: AppStateService
  ) { }

  public get ebookResourceType() {
    return ResourceType.Ebook
  }

  public isGmat() {
    return this._appStateService.path.title.match(/(?:^|\W)gmat(?:$|\W)/i);
  }
  
}



// WEBPACK FOOTER //
// ./src/app/ebook-resources/ebook-resources.component.ts